import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "divide-y divide-[#E6E6E6] my-2" }

import Traveler from './Traveler.vue';

  
export default {
  __name: 'Travelers',
  props: {
    travelers: {
      type: Array,
      default: () => ([])
    },
    post: {
      type: Object,
      default: null,
    },
    trad: {
      type: Object,
      required: true,
    },
    total: {
      type: Number,
      required: false,
    }
  },
  setup(__props) {

  const props = __props

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("small", null, _toDisplayString(__props.trad.error_no_traveler), 1 /* TEXT */)
    ], 512 /* NEED_PATCH */), [
      [_vShow, __props.total < 1]
    ]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.travelers, (traveler) => {
        return (_openBlock(), _createBlock(Traveler, {
          label: traveler.label,
          description: traveler.description,
          name: traveler.name,
          modelValue: traveler.value,
          "onUpdate:modelValue": $event => ((traveler.value) = $event),
          post: __props.post,
          trad: __props.trad
        }, null, 8 /* PROPS */, ["label", "description", "name", "modelValue", "onUpdate:modelValue", "post", "trad"]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}
}

}